import { jsxs as t, jsx as e } from "react/jsx-runtime";
import { tv as c } from "../tailwind-variants.config.js";
import { InfoBubbleIcon as l } from "../Icons/communication/InfoBubbleIcon.js";
import { AlertIcon as s } from "../Icons/communication/AlertIcon.js";
import { WarningBubbleIcon as f } from "../Icons/communication/WarningBubbleIcon.js";
import { Button as g } from "../Button/index.js";
import { NavigationButton as w } from "../NavigationButton/index.js";
const x = c({
  slots: {
    wrapper: "jm-flex jm-gap-4 jm-p-6 jm-box-border jm-rounded-lg jm-outline jm-outline-2 -jm-outline-offset-2",
    icon: "jm-h-fit jm-w-fit",
    content: "jm-flex jm-grow jm-flex-col jm-gap-4"
  },
  variants: {
    type: {
      neutral: {
        wrapper: "jm-bg-jutro-new-blue-50 jm-outline-jutro-new-blue-300",
        icon: "jm-text-blue-600",
        content: "jm-text-blue-900"
      },
      warning: {
        wrapper: "jm-bg-jutro-new-orange-50 jm-outline-jutro-new-orange-300",
        icon: "jm-text-orange-600",
        content: "jm-text-orange-900"
      },
      negative: {
        wrapper: "jm-bg-jutro-new-rose-50 jm-outline-jutro-new-rose-300",
        icon: "jm-text-rose-600",
        content: "jm-text-rose-900"
      },
      positive: {
        wrapper: "jm-bg-jutro-new-green-50 jm-outline-jutro-new-green-300",
        icon: "jm-text-green-600",
        content: "jm-text-green-800"
      }
    },
    full: {
      true: { wrapper: "jm-w-full" },
      false: { wrapper: "jm-w-fit" }
    }
  },
  defaultVariants: {
    type: "neutral",
    full: !0
  }
}), b = {
  neutral: /* @__PURE__ */ e(l, {}),
  warning: /* @__PURE__ */ e(s, {}),
  negative: /* @__PURE__ */ e(f, {}),
  positive: /* @__PURE__ */ e(l, {})
}, k = ({
  title: n,
  description: a,
  handleClose: r,
  actionButton: o,
  type: m = "neutral",
  full: j
}) => {
  const { wrapper: i, icon: u, content: p } = x({ type: m, full: j });
  return /* @__PURE__ */ t("div", { className: i(), children: [
    /* @__PURE__ */ e("div", { className: u(), children: b[m] }),
    /* @__PURE__ */ t("div", { className: p(), children: [
      /* @__PURE__ */ t("div", { className: "jm-flex jm-flex-col jm-gap-2", children: [
        n ? /* @__PURE__ */ e("h4", { className: "jm-font-heading-4 jm-m-0", children: n }) : null,
        /* @__PURE__ */ e("p", { className: "jm-font-paragraph-1 jm-m-0", children: a })
      ] }),
      o ? /* @__PURE__ */ e(
        g,
        {
          ...o,
          full: !1,
          type: "button",
          variant: "secondary"
        }
      ) : null
    ] }),
    r ? /* @__PURE__ */ e(w, { onClick: r }) : null
  ] });
};
export {
  k as Banner
};
//# sourceMappingURL=index.js.map
